import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Grid, Paper, TextField, Checkbox, FormControlLabel, Button} from '@material-ui/core';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux';
import * as Actions from './store/actions'

const styles = theme => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: '80%',
    },
    textFieldSearch: {
        marginLeft: theme.spacing.unit,
        width: '95%',
    },
    button: {
        margin: theme.spacing.unit,
    },
    editor: {
        "min-height": "150px"
    },
    root: {
        backgroundColor: theme.palette.background.paper,
        width: 500,
    },
});

class CompanyQualifications extends Component {

    handleChange = field_name => event => {

        let value = event.target.value;
        if (event.target.type === 'checkbox') {
            value = event.target.checked ? 1 : 0;
        }

        const update_data = {
            [field_name]: value
        }

        this.props.updateQualificationForm(update_data)
    }

    render() {
        const { selectedQualification, classes } = this.props
        return (
            <Grid container spacing={24}>
                <Grid item xs={8}>
                </Grid>
                <Grid item xs={4}>
                    <form style={styles.insidePaper} autoComplete="off">
                        <Grid item xs={12}>
                            <TextField
                                required
                                id="QualificationName"
                                label="Qualification Name"
                                className={classes.textField}
                                value={selectedQualification.QualificationName}
                                onChange={this.handleChange('QualificationName')}
                                margin="normal"
                                variant="outlined"
                            // error={validator.filter(v => v.field_name === 'CompanyName')[0].error}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                id="QualificationDescription"
                                label="Description"
                                className={classes.textField}
                                value={selectedQualification.QualificationDescription}
                                onChange={this.handleChange('QualificationDescription')}
                                margin="normal"
                                variant="outlined"
                            // error={validator.filter(v => v.field_name === 'CompanyName')[0].error}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                required
                                id="QualificationText"
                                label="Qualification Text"
                                className={classes.textField}
                                value={selectedQualification.QualificationText}
                                onChange={this.handleChange('QualificationText')}
                                margin="normal"
                                variant="outlined"
                            // error={validator.filter(v => v.field_name === 'CompanyName')[0].error}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        style={{ marginLeft: '10px' }}
                                        checked={(selectedQualification.RequireAsset === 1)}
                                        onChange={this.handleChange('RequireAsset')}
                                        value="Active"
                                        color="primary"
                                    />
                                }
                                label="Active"
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Button
                                variant="contained"
                                className={classes.button}
                                onClick={() => this.props.saveQualification(this.props.selectedQualification)}
                            >
                                Save
                            </Button>
                        </Grid>

                    </form>
                </Grid>
            </Grid >

        )
    }

}


function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        updateQualificationForm:    Actions.updateQualificationForm,
        saveQualification:          Actions.saveQualification
    }, dispatch)
}

function mapStateToProps({ companyApp }) {
    return {
        allQualifications:          companyApp.companyQualifications.allQualifications,
        selectedQualification:      companyApp.companyQualifications.selectedQualification
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(CompanyQualifications)));



// WEBPACK FOOTER //
// src/main/content/company/CompanyQualifications.js